// extracted by mini-css-extract-plugin
export var details = "_kt-0";
export var inspectorPopover = "_kt-1";